import { showAppErrorToast } from "../components/errors/appErrorBridge";

export { toastPartnerApiFailure } from "../components/errors/toastPartnerApiFailure";

/**
 * Toast error helper — prefers registered implementation from {@link AppErrorsProvider}.
 * Multiple simultaneous messages each trigger their own stacked Spectrum toast (with dismiss UX).
 */
const throwError = (message, timeoutVar = 10000) => {
  showAppErrorToast(message, {
    onClose: () => {},
    timeout: timeoutVar,
  });
};
export default throwError;
